import React from 'react';
import { withTranslation, Trans } from 'react-i18next';
import { connectAlita } from 'redux-alita';
import { Icon, message, Table, Button } from 'antd';
import dataSvg from '../../style/imgs/no_data.svg';
import EditorComponent from './EditorComponent/index.jsx'
import { regionsOptions } from './Const'
import { getUpdateLog, delUpdateLog, postUpdateLog } from '../../axios';
import './index.less';
@withTranslation(['common'])
class UpdateLog extends React.Component {
    constructor(props) {
        super(props);
        const t = this.props.t
        this.state = {
            data: [],
            loading: true,
            isShowEditModal: false,
            page: 1,
            per_page: 10,
            per_total: 0,
            editData: null
        }
    }

    componentDidMount() {
        this.init()
    }

    init = () => {
        const { page, per_page } = this.state
        let data = { page: page, pageSize: per_page }
        getUpdateLog(data).then((res) => {
            if (res.code === 100000) {
                this.setState({
                    data: res.data ? res.data : [],
                    page: res.headers.page,
                    per_total: res.headers.per_total,
                    loading: false
                })
            }
        })
    }

    pageChange = (page, pageSize) => {
        this.setState({
            page: page
        }, () => {
            this.init()
        })
    }

    delete = (record) => {
        delUpdateLog({ logId: record.id }).then(res => {
            if (res.code === 100000) {
                message.success(res.msg)
                this.init()
            } else {
                message.warn(res.msg)
            }
        })
    }

    retry = (record) => {
        message.loading(this.props.t('Retrying'), 2)
        let data = {
            "logDate": record.log_date,
            "features": record.features,
            "issues": record.issues,
            "al": record.al,
            "region": record.region
        }
        postUpdateLog(data).then(res => {
            if (res.code === 100000) {
                message.success(this.props.t('PublishedTips'))
            } else {
                const failedRegions = res.data.failedRegions.map(item => {
                    const findItem = regionsOptions.find(option => option.value === item)
                    return findItem ? findItem.label : item
                })
                const msg = (
                    <Trans i18nKey="FailedTips" values={{ region: failedRegions.join(',') }} t={this.props.t} />
                )
                message.error(res.data.failedRegions && res.data.failedRegions.length > 0 ? msg : res.msg)
            }
            this.init()
        })
    }

    edit = (record) => {
        this.setState({
            isShowEditModal: true,
            editData: record
        })
    }

    removeHtmlTags = (str) => {
        return str ? str.replace(/<[^>]+>/g, "") : "";
    }

    render() {
        const { data, page, per_page, per_total, loading, isShowEditModal, editData } = this.state
        const t = this.props.t
        let columns = [
            {
                title: <span>{t('Date')}</span>,
                dataIndex: 'log_date',
                width: '15%'
            },
            {
                title: <span>{t('language')}</span>,
                dataIndex: 'al',
                width: '15%',
                render: (text, record) => (
                    <span>
                        {text === 'en-US' ? 'English' : 'Chinese'}
                    </span>
                )
            },
            {
                title: <span>{t('New features')}</span>,
                dataIndex: 'features',
                width: '20%',
                render: (text, record) => (
                    <div className='text-ellipsis'>
                        {this.removeHtmlTags(text)}
                    </div>
                )
            },
            {
                title: <span>{t('Resolved issues')}</span>,
                dataIndex: 'issues',
                width: '20%',
                render: (text, record) => (
                    <div className='text-ellipsis'>
                        {this.removeHtmlTags(text)}
                    </div>
                )
            },
            {
                title: <span>{t('Status')}</span>,
                dataIndex: 'failedRegions',
                width: '15%',
                render: (text, record) => {
                    const failedRegions = text.length > 0 ? ` (${text.join(',').toUpperCase()})` : '';
                    return (
                        <span>
                            <span className='round' style={{ background: text.length === 0 ? '#73CA8A' : '#FF0000' }}></span>
                            <span style={{ color: text.length === 0 ? '#73CA8A' : '#FF0000' }}>{text.length === 0 ? t('Published') : t('Failed') + failedRegions}</span>
                        </span>
                    )
                }
            },
            {
                title: t('Operations'),
                width: '15%',
                render: (text, record) => (
                    <span className='invited-action'>
                        <a onClick={() => { this.edit(record) }}><i className="icon-edit cF"></i></a>
                        <a onClick={() => { this.delete(record) }}><i className='icon-delete cF'></i></a>
                        <a hidden={record.failedRegions.length === 0} onClick={() => { this.retry(record) }}><i className='icon-retry cF'></i></a>
                    </span>
                )
            }
        ]

        const customExpandIcon = (props) => {
            if (props.expanded) {
                return <Icon type="down" onClick={props.onExpand} />;
            } else {
                return <Icon type="right" onClick={props.onExpand} />;
            }
        };
        return (
            <div className="main-new">
                <div className="main-cotent">
                    <div className="cotent cotent-wrap" style={{ padding: '10px' }}>
                        <Button onClick={() => { this.setState({ isShowEditModal: true, editData: null }) }}>
                            {t('AddLogs')}
                        </Button>
                        <div className="table-wrap-new pd-top-10">
                            <Table
                                rowKey={record => record.id}
                                columns={columns}
                                dataSource={data}
                                loading={loading}
                                expandIcon={customExpandIcon}
                                expandedRowRender={record => (
                                    <div style={{ display: 'flex' }}>
                                        <div style={{ width: '15%' }}></div>
                                        <div style={{ width: '15%' }}></div>
                                        <div style={{ width: '20%', padding: '11px 16px' }}>
                                            <div dangerouslySetInnerHTML={{ __html: record.features }} />
                                        </div>
                                        <div style={{ width: '20%', padding: '11px 16px' }}>
                                            <div dangerouslySetInnerHTML={{ __html: record.issues }} />
                                        </div>
                                        <div style={{ width: '15%' }}></div>
                                        <div style={{ width: '15%' }}></div>
                                    </div>
                                )}
                                pagination={{ current: page, pageSize: per_page, total: per_total, onChange: this.pageChange }}
                                locale={{
                                    emptyText:
                                        <div className='empty-table'>
                                            <img src={dataSvg} alt=''></img>
                                            <p> {t('NoData')}</p>
                                        </div>
                                }}
                                scroll={{ x: '100%' }} />
                        </div>
                    </div>
                </div>
                {isShowEditModal && <EditorComponent
                    visible={isShowEditModal}
                    editData={editData}
                    close={(type) => {
                        this.setState({ isShowEditModal: false, editData: null });
                        if (type) {
                            this.init()
                        }
                    }}
                />}
            </div>
        )
    }
}

export default connectAlita(['serverConfig'])(UpdateLog)
